import { render, staticRenderFns } from "./TextAreaEditorVariables.vue?vue&type=template&id=7124cd84"
import script from "./TextAreaEditorVariables.vue?vue&type=script&lang=js"
export * from "./TextAreaEditorVariables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports